import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import SubmitToAuditorModal from "./SubmitToAuditorModal";
import * as api from "../../../../backend/request";
import { hasUserAccess, getUserDetails, getUserRole } from "../../../../backend/auth";
import EditActivityModal from "./EditActivityModal";
import { toast } from 'react-toastify';
import PageLoader from "../../../shared/PageLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faEllipsisV, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import BulkUploadModal from "./BulkuploadModal";
import { Link, usePath, useHistory, navigate } from "raviger";
import Table, { CellTmpl, DEFAULT_PAYLOAD, TitleTmpl, reactFormatter } from "../../../common/Table";
import {
    ACTIONS, ACTIVITY_STATUS, AUDIT_STATUS,
    FILTERS, STATUS_MAPPING, TOOLTIP_DELAY
} from "../../../common/Constants";
import Location from "../../../common/Location";
import { useExportTodos, useGetAllActivities } from "../../../../backend/query";
import Icon from "../../../common/Icon";
import { download, downloadFileContent, preventDefault, reduceArraytoObj } from "../../../../utils/common";
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from 'react-bootstrap/Tooltip';
import AdvanceSearch from "../../../common/AdvanceSearch";
import AlertModal from "../../../common/AlertModal";
import { ACTIVITY_TYPE, ACTIVITY_TYPE_ICONS, API_DELIMITER, ERROR_MESSAGES } from "../../../../utils/constants";
import { getAuditReportFileName, useAuditReport, useAuditReportForVendor } from "../../../../backend/exports";
import { USER_PRIVILEGES } from "../../UserManagement/Roles/RoleConfiguration";
import styles from "./TaskManagement.module.css";
import TableActions, { ActionButton } from "../../../common/TableActions";
import SendEmailModal from "../../Auditor/SendEmailModal";
import VendorBulkUploadModal from "./VendorBulkModal";
import { AxiosError } from "axios";
import {
    AUDIT_STATUS_COLOR_CODES,
  AUDIT_STATUS_LABELS,
  AUDIT_STATUS as LOCATION_AUDIT_STATUS,
  canSubmitToAuditor,
  getNewAuditStatusAfterSubmit
} from "../../../../utils/auditStateMachine";
import AuditLocationFilters from "../../../common/AuditLocationFilters";
import { IconButton } from "@mui/material";
import { IoMdInformationCircleOutline } from "react-icons/io";
import AuditDetailsModal from "./AuditDetailsModal";

const STATUS_BTNS = [
    { name: ACTIVITY_STATUS.ACTIVITY_SAVED, label: STATUS_MAPPING[ACTIVITY_STATUS.ACTIVITY_SAVED], style: 'secondary' },
    { name: ACTIVITY_STATUS.PENDING, label: STATUS_MAPPING[ACTIVITY_STATUS.PENDING], style: 'warning' },
    { name: ACTIVITY_STATUS.OVERDUE, label: STATUS_MAPPING[ACTIVITY_STATUS.OVERDUE], style: 'danger' },
    { name: ACTIVITY_STATUS.SUBMITTED, label: STATUS_MAPPING[ACTIVITY_STATUS.SUBMITTED], style: 'danger' },
    { name: ACTIVITY_STATUS.REJECTED, label: STATUS_MAPPING[ACTIVITY_STATUS.REJECTED], style: 'danger' },
    { name: ACTIVITY_STATUS.AUDITED, label: STATUS_MAPPING[ACTIVITY_STATUS.AUDITED], style: 'danger' }
];

const SortFields: any = {
    'act.name': 'act_name',
    'rule.name': 'rule_name',
    'activity.name': 'activity_name',
    'activity.activity_type': 'activity_activity_type',
    'associate_company.name': 'associate_company_name',
    'location.name': 'location_name'
};

// const AuditTypeFilter = [{ columnName: 'auditted', value: ACTIVITY_TYPE.AUDIT }];
const AuditTypeFilter: any[] = [];

function getAdvanceSearch(state: any) {
    const filters: any = {};
    if ((state || {}).fromDate) {
        filters['from_date_gteq'] = dayjs(state.fromDate).startOf('D').toISOString()
        filters['to_date'] = dayjs(state.toDate).endOf('D').toISOString()
    }

    if ((state || {}).audit_type) {
        filters['audit_type'] = state.auditType
    }
    return filters || undefined;
}

const include = ['company', 'associate_company', 'location', 'preliminary_report', 'final_report'];
const includes = ['company', 'associate_company', 'location', 'preliminary_report', 'final_report'];

function ActivitiesManagement({ auditId }: any) {
    const { state }: any = useHistory();
    const [action, setAction] = useState(ACTIONS.NONE);
    const [statusBtns] = useState(STATUS_BTNS);
    const [submitting, setSubmitting] = useState(false);
    const [checkedStatuses, setCheckedStatuses] = useState<any>((state || {}).status ? { [state.status]: true } : {});
    const [activity, setActivity] = useState<any>(null);
    const [bulkUpload, setBulkUpload] = useState(false);
    const [vendorUpload, setVendorUpload] = useState<boolean>(false);
    const [submitToAuditor, setSubmitToAuditor] = useState(false);
    const path: any = usePath();
    const [fromDashboard] = useState(path.includes('/dashboard/activities'));
    const [data, setData] = useState<any>();
    const [params, setParams] = useState<any>();
    const [advaceSearchFilters, setAdvanceSearchFilters] = useState(getAdvanceSearch(state));
    const afRef: any = useRef();
    afRef.current = advaceSearchFilters;
    const [statusFilters, setStatusFilters] = useState<any>();
    const sfRef = useRef();
    sfRef.current = statusFilters;
    const [payload, setPayload] = useState<any>();
    const payloadRef = useRef();
    payloadRef.current = payload;
    const { activities, total, isFetching, refetch } = useGetAllActivities(payload, Boolean(hasFilters(null, 'location_audit_id_eq')));
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [alertMessage, setAlertMessage] = useState<any>(null);
    const [currentAudit, setCurrentAudit] = useState<any>({});
    const [showAuditDetails, setShowAuditDetails] = useState(false);
    const [selectedReportForDownload, setSelectedReportForDownload] = useState<any>(null);
    const [userRole] = useState(getUserRole());
    const { auditReport, exporting } = useAuditReport((response: any) => {
        if (response) {
            const filename = selectedReportForDownload && selectedReportForDownload.name ? selectedReportForDownload.name.charAt(0).toUpperCase() + selectedReportForDownload.name.slice(1) : 'audit_report';
            downloadFileContent({
                name: filename,
                type: response.headers['content-type'],
                content: response.data
            });
        }
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT)
    });
    const { exportTodos, exporting: exportingTodos } = useExportTodos((response: any) => {
        downloadFileContent({
            name: 'Audit Activities.xlsx',
            type: response.headers['content-type'],
            content: response.data
        });
    }, () => {
        toast.error(ERROR_MESSAGES.DEFAULT);
    });

    useEffect(() => {
        if (auditId) {
            refetchAudit();
        } else {
            navigate('/location-audits');
        }
    }, [auditId]);

    useEffect(() => {
        if (currentAudit && currentAudit.id) {
            setAdvanceSearchFilters({
                location_audit_id_eq: currentAudit.id
            });
        }
    }, [currentAudit]);

    async function refetchAudit() {
        if (auditId) {
            try {
                const response = await api.get(`/api/v1/location_audits/${auditId}`, {
                    include: include,
                    includes: includes
                });
                if (response && response.data) {
                    setCurrentAudit(response.data);
                }
            } catch (error) {
                console.error('Error refreshing audit:', error);
            }
        }
    }

    const buttons: ActionButton[] = [
        {
            label: 'Submit to Auditor',
            name: 'submitToAuditor',
            privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_SUBMIT,
            action: () => {
                onSubmitToAuditor();
            }
        }
    ];

    const downloadReportButtons: ActionButton[] = [
        {
            label: "Preliminary Report",
            name: "preliminaryReport",
            privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT,
            action: () => {
                downloadReport(null, 'preliminary');
            },
        },
        {
            label: "Final Report",
            name: "finalReport",
            privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES_DOWNLOAD_REPORT,
            action: () => {
                downloadReport(null, 'final');
            },
        }
    ];


    function editActivity(activity: any) {
        setActivity(activity);
    }

    function downloadForm(activity: any) {
        setSubmitting(true);
        api.get(`/api/v1/act_state_mappings/${activity.act_state_mapping_id}`).then(response => {
            if (response.data.file_path) {
                download(response.data.file_name, response.data.file_path)
            } else {
                toast.warn('No files available');
            }
        }).finally(() => setSubmitting(false));
    }

    async function downloadReport(event: any, reportType: 'preliminary' | 'final') {
        preventDefault(event);
        if (currentAudit && currentAudit.id) {
            if(reportType == 'preliminary' && [LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED].includes(currentAudit.status)){
                toast.warn("Preliminary report is not available as Preliminary audit is not yet published.");
                return;
            }
            if(reportType == 'final' && [LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_PENDING, LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED, LOCATION_AUDIT_STATUS.FINAL_AUDIT_PENDING, LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED].includes(currentAudit.status)){
                toast.warn("Final report is not available as Final audit is not yet published.");
                return;
            }
            setSubmitting(true);
            try {
                let reportData: any;
                if(currentAudit && currentAudit.preliminary_report || currentAudit.final_report){
                    reportData = reportType == 'preliminary' ? currentAudit.preliminary_report : currentAudit.final_report;
                } else {
                    const response = await api.get(`/api/v1/location_audits/${currentAudit.id}`, {
                        include: include,
                        includes: includes
                    });
                    reportData = reportType == 'preliminary' ? response.data.preliminary_report : response.data.final_report;
                }
                setSelectedReportForDownload(reportData);

                const { s3_region, s3_key, s3_bucket } = reportData || {};
                if (s3_region && s3_key && s3_bucket) {
                    auditReport({
                        s3_region,
                        s3_key,
                        s3_bucket
                    });
                } else {
                    const reportTypeName = reportType.charAt(0).toUpperCase() + reportType.slice(1);
                    toast.warn(`${reportTypeName} report is not available`);
                }
            } catch (error) {
                console.error('Error fetching audit:', error);
            }
            setSubmitting(false);
        }
    }

    function onSubmitToAuditor() {
        if(!canSubmitToAuditor(currentAudit, userRole)) {
            toast.error("You cannot submit activities to auditor at this stage.");
        } else {
            setSubmitting(true);
            const _payload: any = {
                filters: {
                    location_audit_id_eq: currentAudit.id
                }
            };
            api.get('/api/v1/todos', _payload).then(response => {
                if (response && response.data) {
                    const _rows = (response.data || {data: {}}).items || [];
                    const _applicableRows = _rows.filter((x: any) => ![ACTIVITY_STATUS.AUDITED, ACTIVITY_STATUS.SUBMITTED].includes(x.status));
                    const _published = _applicableRows.filter((x: any) => x.published);
                    if (_published.length > 0) {
                        setAlertMessage('All the activities are published for the selected month and year. See Audit report for more details.');
                    } else if (_applicableRows.length) {
                        setSelectedRows(_applicableRows);
                        setSubmitToAuditor(true);
                    } else if([LOCATION_AUDIT_STATUS.FINAL_AUDIT_PENDING].includes(currentAudit.status)) {
                        setSelectedRows(_applicableRows);
                        setSubmitToAuditor(true);
                    } else {
                        toast.warn('There are no activities available for submission.');
                    }
                }
            }).finally(() => setSubmitting(false));
        }
    }

    async function submitToAuditorPreliminaryAudit(todoIds: any[]) {
        setSubmitting(true);
        try {
            const newAuditStatus = LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED;
            const updatePayload = {
                todo_ids: todoIds,
            };
            let response: any = await api.put(`/api/v1/location_audits/${currentAudit.id}/${newAuditStatus}`, updatePayload);
            if (response instanceof AxiosError) {
                toast.error("Failed to submit preliminary audit. Please try again.");
            } else {
                setTimeout(() => {
                    toast.success("Activities submitted to auditor successfully.");
                    refetch();
                    refetchAudit();
                    setSubmitToAuditor(false);
                    setSubmitting(false);
                }, 2000);
            }
        } catch (error) {
            toast.error("Failed to submit activities. Please try again.");
            console.error('Error submitting activities:', error);
            setSubmitToAuditor(false);
            setSubmitting(false);
        }
    }

    async function submitToAuditorFinalAudit(todoIds: any[]) {
        setSubmitting(true);
        try {
            const newAuditStatus = LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED;
            const updatePayload = {
                todo_ids: todoIds,
            };
            let response: any = await api.put(`/api/v1/location_audits/${currentAudit.id}/${newAuditStatus}`, updatePayload);
            if (response instanceof AxiosError) {
                toast.error("Failed to submit final audit. Please try again.");
            } else {
                setTimeout(() => {
                    toast.success("Final audit submitted successfully.");
                    refetch();
                    refetchAudit();
                    setSubmitToAuditor(false);
                    setSubmitting(false);
                }, 2000);
            }
        } catch (error) {
            toast.error("Failed to submit activities. Please try again.");
            console.error('Error submitting activities:', error);
            setSubmitToAuditor(false);
            setSubmitting(false);
        }
    }

    async function onSubmitToAuditorHandler(e: any) {
        preventDefault(e);
        const todoIds = selectedRows.map(x => x.id);
        const newAuditStatus = getNewAuditStatusAfterSubmit(currentAudit.status);
        
        if (newAuditStatus !== currentAudit.status) {
            // Call appropriate function based on state machine result
            if (newAuditStatus === LOCATION_AUDIT_STATUS.PRELIMINARY_AUDIT_SUBMITTED) {
            await submitToAuditorPreliminaryAudit(todoIds);
            } else if (newAuditStatus === LOCATION_AUDIT_STATUS.FINAL_AUDIT_SUBMITTED) {
            await submitToAuditorFinalAudit(todoIds);
            }
        }
    }

    function onFormStatusChangeHandler(e: any) {
        setCheckedStatuses({
            ...(checkedStatuses || {}),
            [e.target.name]: e.target.checked
        });
    }

    function search(event: any) {
        const _filters: any = {
            location_audit_id_eq: (currentAudit || {}).id
        };
        const keys = Object.keys(event || {});
        if (keys.length > 0) {
            keys.forEach(key => {
                _filters[key] = event[key]
            });
        }
        setAdvanceSearchFilters(_filters);
    }

    function MonthTmpl({ cell }: any) {
        const row = cell.getData();
        return (
            <>{row.month} ({row.year})</>
        )
    }
    function DueDateTmpl({ cell }: any) {
        const value = cell.getValue();
        return (
            <span className="text-warn" >{dayjs(value).format('DD-MM-YYYY')}</span>
        )
    }

    function ActionHeaderTmpl() {
        return (
            <div className={`nav-item dropdown ${styles.tableActions}`}>
                <div className="nav-link text-white" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <FontAwesomeIcon icon={faEllipsisV} />
                </div>
                <div className="dropdown-menu">
                    <a className="dropdown-item" onClick={handleExport}>Export</a>
                    {
                    selectedRows.length !== 0 && 
                    <a className="dropdown-item" onClick={(e) => {e.preventDefault();setVendorUpload(true)}}>Bulk Upload</a>
                    }
                </div>
            </div>
        )
    }

    function FormStatusTmpl({ cell }: any) {
        const status = cell.getValue();
        const row = cell.getData();
        return (
            <div className="d-flex align-items-center position-relative">
                {!!row.forms_status_remarks && (
                    <OverlayTrigger
                        overlay={<Tooltip>
                            <div dangerouslySetInnerHTML={{ __html: row.forms_status_remarks }}></div>
                        </Tooltip>}
                        placement="bottom"
                        delay={{ show: TOOLTIP_DELAY } as any}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    </OverlayTrigger>
                )}
                <span className={`status-${status} ellipse`}>
                    {STATUS_MAPPING[status] || status}
                </span>
            </div>
        );
    }

    function AuditStatusTmpl({ cell }: any) {
        const status = cell.getValue();
        const row = cell.getData();
        const color = {
            [AUDIT_STATUS.COMPLIANT]: 'status-compliant',
            [AUDIT_STATUS.NON_COMPLIANCE]: 'status-non-compliance',
            [AUDIT_STATUS.NOT_APPLICABLE]: 'status-not-applicable',
        };
        return (
            <div className="d-flex align-items-center position-relative">
                {!!row.audit_remarks && (
                    <OverlayTrigger
                        overlay={<Tooltip>
                            <div dangerouslySetInnerHTML={{ __html: row.audit_remarks }}></div>
                        </Tooltip>}
                        placement="bottom"
                        delay={{ show: TOOLTIP_DELAY } as any}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    </OverlayTrigger>
                )}
                {status && (
                    <span className={`${color[status]} ellipse`}>
                        {STATUS_MAPPING[status] || status}
                    </span>
                )}
            </div>
        );
    }

    function ActionColumnElements({ cell }: any) {
        const row = cell.getData();

        return (
            <div className="d-flex flex-row align-items-center position-relative">
                <Icon className="mx-2" type="button" name={hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES_UPLOAD) ? 'pencil' : 'eye'}
                    text={hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES_UPLOAD) ? 'Edit' : 'View'} data={row} action={editActivity} />
                <Icon className="ms-1" type="button" name="download" text="Download" data={row} action={downloadForm} />
            </div>
        )
    }

    function ActivityTypeTmpl({ cell }: any) {
        const value = cell.getValue() || ACTIVITY_TYPE.AUDIT;
        return (
            <div className="d-flex flex-row align-items-center justify-content-center position-relative">
                <Icon name={ACTIVITY_TYPE_ICONS[value]} text={value} />
            </div>
        )
    }

    const columns = [
        {
            title: "", field: "auditted", width: 40,
            formatter: reactFormatter(<ActivityTypeTmpl />)
        },
        {
            title: "Month & Year", field: "month", width: 140,
            formatter: reactFormatter(<MonthTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            headerClick: (e: any, col: any) => {
                preventDefault(e);
            }
        },
        {
            title: "Act", field: "act.name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },

        {
            title: "Rule", field: "rule.name", widthGrow: 2,
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Activity", field: "activity.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 2
        },
        {
            title: "Activity Type", field: "activity.activity_type",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Associate Company", field: "associate_company.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 1
        },
        {
            title: "Location Name", field: "location.name",
            formatter: reactFormatter(<CellTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />),
            widthGrow: 1
        },
        {
            title: "Audit Due Date", field: "due_date", width: 120,
            formatter: reactFormatter(<DueDateTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Compliance Status", field: "audit_status", maxWidth: 160,
            formatter: reactFormatter(<AuditStatusTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Evidence Status", field: "status", maxWidth: 160,
            formatter: reactFormatter(<FormStatusTmpl />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        },
        {
            title: "Actions", hozAlign: "center", width: 100,
            headerSort: false,
            formatter: reactFormatter(<ActionColumnElements />),
            titleFormatter: reactFormatter(<TitleTmpl />)
        }
    ]

    const [tableConfig] = useState({
        paginationMode: 'remote',
        ajaxRequestFunc,
        columns,
        rowHeight: 'auto',
        selectable: getUserRole() === 'Vendor User' ? true : false,
        paginate: true,
        initialSort: ['month desc'],
        rowFormatter
    });

    function rowFormatter(row: any) {
        const data = row.getData();
        const element = row.getElement();
        if (data.published) {
            element.classList.add('activity-published');
        }
    }

    function formatApiResponse(params: any, list: any, totalRecords: number) {
        const { page, per } = params || {};
        const tdata = {
            data: list,
            total: totalRecords,
            last_page: Math.ceil(totalRecords / (per || 1)) || 1,
            page: page || 1
        };
        setData(tdata);
        return tdata;
    }

    function hasFilters(ref: any, field = 'location_audit_id_eq') {
        const _filters: any = (ref ? ref.current : ({ ...(payloadRef.current || {}) } as any)['filters']) || {};
        return _filters[field];
    }

    function backToAuditList(event: any) {
        event.preventDefault();
        navigate('/location-audits', {
            state: {
                ...(state || {})
            }
        });
    }

    function ajaxRequestFunc(url: any, config: any, params: any) {
        const { field, dir } = (params.sort || [])[0] || {};
        const _params = {
            per: params.size,
            page: params.page,
            sorts: [`${SortFields[field] || field || 'month'} ${dir || 'desc'}`],
            include: ['act', 'rule', 'activity', 'location', 'associate_company', 'company'],
            includes: ['act', 'rule', 'activity', 'location', 'associate_company', 'company']
        };
        setParams(_params);
        setPayload({
            ...DEFAULT_PAYLOAD,
            ..._params,
            filters: {
                ...(afRef.current || []),
                ...(sfRef.current || []),
                ...AuditTypeFilter
            }
        });
        return Promise.resolve(formatApiResponse(params, activities, total));
    }

    function handlePageNav(_pagination: any) {
        const _params = { ...params, ..._pagination };
        setParams({ ..._params });
        setPayload({ ...payload, ..._params });
    }

    function getAdvanceSearchPayload() {
        const _filters = {...(afRef.current || {})};
        const _payload: any = {..._filters};
        return _payload;
    }

    function handleVendorBulkUploadClose(refresh = false) {
        if (refresh) {
            refetch();
        }
        setVendorUpload(false);
    }
    function handleBulkUploadClose(refresh = false) {
        if (refresh) {
            refetch();
        }
        setBulkUpload(false);
    }

    function handleExport(event: any) {
        event.preventDefault();
        if (total < 1) {
            toast.warn('There are no records available for this filter criteria.');
            return;
        }
        const _payload = {
            ...DEFAULT_PAYLOAD,
            sorts: ['month desc'],
            ...params,
            filters: {
                ...(afRef.current || {}),
                ...(sfRef.current || {}),
                ...AuditTypeFilter
            },
            page: 1,
            per: total
        };

        _payload.include = {
            act: [], rule: [], activity: [], location: [], associate_company: [],
            act_state_mapping: {
                include: ['rule_compliance_detail']
            }
        }
        exportTodos(_payload);
    }

    useEffect(() => {
        if (advaceSearchFilters && advaceSearchFilters.location_audit_id_eq) {
            const _params = { ...params, page: 1 };
            setParams({ ..._params });
            setPayload({
                ...payload,
                ...DEFAULT_PAYLOAD,
                sorts: ['month desc'],
                ..._params,
                filters: {
                    ...(advaceSearchFilters || {}),
                    ...(sfRef.current || {}),
                    ...AuditTypeFilter
                }
            });
        }
    }, [advaceSearchFilters]);

    useEffect(() => {
        if (advaceSearchFilters && advaceSearchFilters.location_audit_id_eq) {
            const _params = { ...params, page: 1 };
            setParams({ ..._params });
            setPayload({
                ...payload,
                ...DEFAULT_PAYLOAD,
                sorts: ['month desc'],
                ..._params,
                filters: {
                    ...(afRef.current || {}),
                    ...(statusFilters || {}),
                    ...AuditTypeFilter
                }
            });
        }
    }, [statusFilters]);

    useEffect(() => {
        if (checkedStatuses) {
            const keys = Object.keys(checkedStatuses);
            const result = keys.filter(key => !!checkedStatuses[key]);
            const _result: any = {};
            if (result.length > 0) {
                _result['status_in'] = result
            }
            setStatusFilters(_result)
        }
    }, [checkedStatuses]);

    useEffect(() => {
        if (!isFetching && payload) {
            setSelectedRows([]);
            setData(formatApiResponse(params, activities, total));
        }
    }, [isFetching])

    return (
        <>
            <div className="d-flex flex-column">
                <div className="d-flex  p-2 align-items-center pageHeading shadow">
                    <h4 className="mb-0">Location Audits</h4>
                    <div className="d-flex align-items-end h-100">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 d-flex justify-content-end">
                                <li className="breadcrumb-item">Home</li>
                                {
                                    fromDashboard &&
                                    <li className="breadcrumb-item fw-bold"><Link href="/dashboard">Dashboard</Link></li>
                                }
                                <li className="breadcrumb-item  fw-bold active"><Link href="/location-audits" onClick={backToAuditList}>Audit Compliances</Link></li>
                                <li className="breadcrumb-item  fw-bold active">
                                    Audit Details
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <form className="p-0 mx-3 my-2">
                    <div className="" style={{ fontSize: '20px', fontWeight: "600" }}>
                        <span style={{cursor: 'pointer'}} onClick={backToAuditList}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                            &nbsp;
                            Activity List
                        </span>
                        <span>
                            &nbsp;-&nbsp;
                            {(currentAudit.location || {}).name || ''}
                        </span>
                        <span>
                            &nbsp;
                            <IconButton onClick={() => setShowAuditDetails(true)} >
                            <IoMdInformationCircleOutline />
                            </IconButton>
                        </span>
                        <span className={`${AUDIT_STATUS_COLOR_CODES[currentAudit.status as keyof typeof AUDIT_STATUS_COLOR_CODES] || 'text-dark-gray'}`} style={{ fontSize: '16px', fontWeight: "500" }}>
                            &nbsp;&nbsp;
                            {AUDIT_STATUS_LABELS[currentAudit.status as keyof typeof AUDIT_STATUS_LABELS] || currentAudit.status}
                        </span>
                    </div>
                    <div className="card shadow border-0 p-2 mt-2 mb-3">
                        <div className="d-flex flex-row filters auditFilters">
                            <AuditLocationFilters onChange={search} />
                        </div>
                    </div>
                    <div className="card shadow border-0 p-2 mb-2">
                        <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center status-btn-group">
                                <label className="filter-label"><small>Forms Status</small></label>
                                {
                                    statusBtns.map(btn => {
                                        return (
                                            <div className="mx-2" key={btn.name}>
                                                <input name={btn.name} type="checkbox" className="btn-check" id={btn.name} autoComplete="off"
                                                    onChange={onFormStatusChangeHandler}
                                                    checked={checkedStatuses[btn.name]} />
                                                <label className={`btn bg-status-${btn.name}`} htmlFor={btn.name}>{btn.label}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                            <div className="d-flex">
                                <div className="px-3 mx-3 d-flex flex-row align-items-center gap-2">
                                    <TableActions buttons={downloadReportButtons} btnLabel="Download Report" />
                                </div>
                                {hasUserAccess(USER_PRIVILEGES.SUBMITTER_ACTIVITIES_SUBMIT) && <TableActions buttons={buttons} />}
                            </div>
                        </div>
                    </div>
                </form>
                <div className="position-relative">
                    <ActionHeaderTmpl />
                    <Table data={data} options={tableConfig} isLoading={isFetching}
                        onSelectionChange={setSelectedRows} onPageNav={handlePageNav} />
                </div>
            </div>

            {showAuditDetails && (
                <AuditDetailsModal
                onClose={() => setShowAuditDetails(false)}
                audit={currentAudit}
                auditType="location"
                />
            )}

            {
                vendorUpload &&
                <VendorBulkUploadModal onClose={handleVendorBulkUploadClose} selectedItems={selectedRows} isVendor={false} />
            }
            {
                bulkUpload &&
                <BulkUploadModal onClose={handleBulkUploadClose} onSubmit={refetch} />
            }
            {
                submitToAuditor &&
                <SubmitToAuditorModal
                    onClose={() => setSubmitToAuditor(false)}
                    onSubmit={onSubmitToAuditorHandler}
                    selectedRows={selectedRows}
                    auditStatus={currentAudit.status} />
            }
            {
                !!activity && selectedRows.length >= 0 &&
                <EditActivityModal activity={activity} onClose={() => setActivity(null)} onSubmit={refetch} selectedItems={selectedRows} auditStatus={currentAudit.status} />
            }
            {
                !!alertMessage &&
                <AlertModal message={alertMessage} onClose={(e: any) => {
                    preventDefault(e);
                    setAlertMessage(null);
                }} />
            }
            {
                action === ACTIONS.SEND_REPORT &&
                <SendEmailModal onCancel={() => setAction(ACTIONS.NONE)} />
            }
            {(submitting || exporting || exportingTodos) && <PageLoader />}
        </>
    ); 
}

export default ActivitiesManagement;
